/* eslint-disable no-restricted-properties */ const roundingModeToMethod = {
    floor: 'floor',
    ceil: 'ceil',
    expand: 'round',
    trunc: 'trunc'
};
// Intl.NumberFormat is buggy with ceil and floor rounding so we round the number before passing it to the Intl formatter.
export default function fixRounding(number, maximumFractionDigits, roundingMode) {
    if (!roundingMode) {
        return number;
    }
    const fractionDigits = maximumFractionDigits;
    const roundingMethod = roundingModeToMethod[roundingMode];
    return Math[roundingMethod](number * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
}

//# sourceMappingURL=fixRounding.js.map